/*
 * Widen asset-url helpers.
 *
 * The photo/video gallery no longer uses this module (that logic moved
 * server-side into GalleryPageController). The only remaining consumer is the
 * product-line mini-gallery, which needs to read the Widen id from an asset url
 * and rewrite the requested image dimensions.
 */

const getDimensionsFromAssetUrl = (url) => {
  // Returns object w/ width/height or null... should be at position 6 in array
  const a = url.split('/');
  if (a[6] !== undefined) {
    if (a[6].indexOf('px') !== -1 && !Number.isNaN(parseInt(a[6], 10))) {
      const b = a[6].split('x');
      return {
        width: parseInt(b[0], 10),
        height: parseInt(b[1], 10),
      };
    }
  }
  return null;
};

const updateAssetUrlDimensions = (asset) => {
  const urlDims = getDimensionsFromAssetUrl(asset.src);
  if (urlDims !== null) {
    return asset.src
      .replace(`${urlDims.width}x`, `${asset.width}x`)
      .replace(`${urlDims.height}px`, `${asset.height}px`);
  }
  return asset.src;
};

const getIdFromAssetUrl = (url) => {
  const fragment = url.match(/springswindowfashions\/(.*?)\//);
  if (fragment !== null) {
    return fragment[1];
  }
  return url;
};

export {
  getIdFromAssetUrl,
  updateAssetUrlDimensions,
};
